import { ITransfersService } from './ITransfersService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, PREVILEGEKEY } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TransferEntity } from '../../../models/Transactions/TransferEntity';
import { retry } from 'rxjs/operators';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';
import { TransactionHeaderEntity } from '../../../models/Transactions/DocumentApprovalEntity';
@Injectable({
  providedIn: 'root'
})
export class TransfersService implements ITransfersService {
  constructor(private httpService: HttpRequestService) { }

  GetTransfersSummary(
    siteId: number,
    transType: number,
    menuId: number,
    selectedLocationId: number = 0, itemId: number = 0, searchText: string = '')
    : Observable<TransferEntity[]> {

    let inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('transType', transType.toString())
      .set('menuId', menuId.toString())
      .set('selectedLocationId', selectedLocationId.toString())
      .set('itemId', itemId.toString())
      .set('APIKEY', PREVILEGEKEY.GetTransfersSummary);
    if (searchText !== '') {
      inputParams = inputParams.append('searchValue', searchText.toString());
    }
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransfersAPI.GetTransfersSummary);
  }

  /**
   * @version UI 13.2
   * @method GetAllTranasction
   * @param QueryParams 
   * @returns 
   */

  GetAllTranasction(QueryParams: any): Observable<any> {
    const transferRequestUrl = apiURLs.TransactionManagement.GetTransferHead + QueryParams;
    return this.httpService.GetHttpRequest(transferRequestUrl);
  }

  /**
   * @version UI 24.3
   * @method GetItemTransferList
   * @param QueryParams 
   * @returns 
   */

  // GetItemTransferList(QueryParams: any): Observable<any> {
  //   const transferRequestUrl = apiURLs.TransactionManagement.GetItemTransferList + '/'+QueryParams.id;
  //   return this.httpService.GetHttpRequest(transferRequestUrl);
  // }

  GetItemTransferList(RequestPayload: any): Observable<any> {
    const transferRequestUrl = apiURLs.TransactionManagement.GetItemTransferList;
    return this.httpService.postHttpRequest(transferRequestUrl, RequestPayload);
  }

   /**
   * @version UI 24.3
   * @method GetAllTransfers
   * @param RequestPayload 
   * @returns 
   */
  GetAllTransfers(RequestPayload: any): Observable<any> {
    const transferRequestUrl = apiURLs.TransactionManagement.GetAllTransfers;
    return this.httpService.postHttpRequest(transferRequestUrl, RequestPayload);
  }

  GetTranasctionDetailsCount(headIds: any): Observable<any> {
    const transferRequestUrl = apiURLs.TransactionManagement.GetDetailsCount + '?headIds=' + headIds;
    return this.httpService.GetHttpRequest(transferRequestUrl);
  }

  GetTransferDetails(menuId: number, transferNumber: number, siteId: number): Observable<TransferEntity> {
    const inputParams = new HttpParams().set('menuId', menuId.toString())
      .set('transferNumber', transferNumber.toString())
      .set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransfersAPI.GetTransfersDetails);

  }

  /**
 * @version 13.2 UI
 * @method GetTransDetails
 * @param transTypeId;
 * @param transferId;
 * @returns;
 * oldmethod - GetTransferDetails
 */

  GetTransDetails(transTypeId: number, transferId: number): Observable<any> {
    const reqHeadUrl = `${apiURLs.TransactionManagement.GetTransferHead}/` + transferId + `?transtype=${transTypeId}`;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }

  PostTransfer(entity: TransferEntity): Observable<ValidationEntity> {
    (entity as any).APIKEY = PREVILEGEKEY.PostTransfer;
    return this.httpService.postHttpRequest(apiURLs.TransfersAPI.SaveTransfer, entity);
  }
  /**
    * @version UI 13.2
    * @method GetTransGetRequistionSummary
    */
  // GetTransferRequistionSummary(TransferRequistionRequestParams: any): Observable<any> {
  //   const requisitionRequestUrl = apiURLs.TransfersAPI.GetTransferRequistionSummary + TransferRequistionRequestParams
  //   return this.httpService.GetHttpRequest(requisitionRequestUrl);
  // }
  GetTransferHeaderSummary(typeId: number = 3): Observable<TransactionHeaderEntity> {
    const requestUrl = apiURLs.InvertoryManagement.GetTransactionHeader + typeId;
    return this.httpService.GetHttpRequest(requestUrl);
  }
  /**
   * @version 13.1 UI
   * @param RequisitionRequestParams 
   * @returns 
   */
  GetTransOpenRequestSummary(RequisitionRequestParams: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetRequisitionHead + RequisitionRequestParams
    return this.httpService.GetHttpRequest(requisitionRequestUrl);
  }

   /**
   * @version 24.3 UI
   * @param requestParams 
   * @returns 
   */
  // GetItemTransactions(requestParams: any): Observable<any> {
  //   const requisitionRequestUrl = apiURLs.TransactionManagement.GetItemTransactions + '/'+requestParams.id + '/'+requestParams.transtype;
  //   return this.httpService.GetHttpRequest(requisitionRequestUrl);
  // }

   /**
   * @version 24.3 UI
   * @param requestParams 
   * @returns 
   */
   GetItemTransactions(requestParams: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetItemTransactions;
    return this.httpService.postHttpRequest(requisitionRequestUrl, requestParams);
  }

    /**
   * @version 13.1 UI
   * @param RequisitionRequestPayload 
   * @returns 
   */
    GetAllRequisitions(RequisitionRequestPayload: any): Observable<any> {
      const requisitionRequestUrl = apiURLs.TransactionManagement.GetAllRequisitions;
      return this.httpService.postHttpRequest(requisitionRequestUrl, RequisitionRequestPayload);
    }

    /**
   * @version 13.2 UI
   * @param PostTrans 
   * @returns 
   */
  PostTrans(entity: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetTransferHead, entity);
  }
}
